import { FC } from "react";
import { HEADER_DEFAULTS, THeaderProps } from "./Header.config";
import { Container } from "../../layout";
import { HeaderLogo } from "./HeaderLogo";
import { HeaderMenu } from "./HeaderMenu";
import { HeaderActions } from "./HeaderActions";

export const Header: FC<THeaderProps> = ({
  actions,
  menu,
  "data-component": component = HEADER_DEFAULTS["data-component"],
}) => (
  <header data-component={component} className="bg-sys-white">
    <Container className="relative h-16 flex justify-between items-center">
      <HeaderActions primary={actions?.primary} />
      <HeaderLogo />
      <HeaderMenu items={menu?.items} />
    </Container>
  </header>
);
